import "./ScrollToTopButton.scss";

import React, { memo, useEffect, useState } from "react";
import { animateScroll as scroll } from "react-scroll";

import { ArrowIcon } from "../icons/ArrowIcon";

const ScrollToTopButton: React.FC = memo(() => {
  const [showButton, setShowButton] = useState(false);

  const scrollPage = () => {
    scroll.scrollToTop({
      duration: 300,
      smooth: true,
    });
  };

  const handleScroll = () => {
    const scrollPosition = window.pageYOffset;
    setShowButton(scrollPosition > 200);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      data-testid="scroll-to-top-button"
      className={`scrolltop text-white ${showButton ? "show" : ""}`}
      style={{ transform: "rotate(90deg)" }}
      onClick={scrollPage}
    >
      <ArrowIcon />
    </div>
  );
});

export { ScrollToTopButton };
